import React from "react";
import { GlassWater, Percent } from "lucide-react";

export default function InfoDrink({ quantity, alcoholPercentage }) {
    return (
        <div className="grid grid-cols-2 gap-3 bg-[#121824] border border-accent/20 rounded-2xl p-4 shadow-md text-sm max-w-sm mx-auto">
            {/* Quantità */}
            <div className="flex flex-col items-center justify-center p-2 bg-background/40 border border-accent/10 rounded-xl text-center">
                <GlassWater className="w-4 h-4 text-primary mb-1" />
                <span className="text-[10px] uppercase tracking-wider text-muted font-bold mb-0.5">Capienza</span>
                <p className="text-secondary font-semibold">{quantity || "-"}</p>
            </div>

            {/* Gradazione */}
            <div className="flex flex-col items-center justify-center p-2 bg-background/40 border border-accent/10 rounded-xl text-center">
                <Percent className="w-4 h-4 text-primary mb-1" />
                <span className="text-[10px] uppercase tracking-wider text-muted font-bold mb-0.5">Gradazione</span>
                <p className="text-secondary font-semibold">{alcoholPercentage ? `${alcoholPercentage}` : "-"}</p>
            </div>
        </div>
    );
}